import React from "react";

import { IconDictionary } from "../Icon/types";
import { ProfilePic } from "../ProfilePic";

import { FacepilePerson } from "./Facepile";
import styles from "./Facepile.scss";

export interface FacepileFacesProps {
  circleClassNames: string[];
  dimensions?: number;
  max: number;
  overflowClassNames: string;
  size: "large" | "medium" | "small";
  tag?: string;
  users: FacepilePerson[];
  wrapperClass: string;
  profilePicIconOverride?: IconDictionary;
  overridePeopleCount?: number;
  active?: boolean;
  highlightActiveFace?: boolean;
  activeUserId?: string;
  onUserClick?: (user: FacepilePerson) => void;
  onUserCountClick?: () => void;
}

export function FacepileFaces({
  circleClassNames,
  dimensions,
  max,
  overflowClassNames,
  size,
  tag,
  users,
  wrapperClass,
  profilePicIconOverride,
  overridePeopleCount = 0,
  active,
  highlightActiveFace = false,
  activeUserId,
  onUserClick,
  onUserCountClick,
}: FacepileFacesProps): React.ReactElement {
  const userCount = overridePeopleCount || users.length;
  let plusCount = userCount - max;
  let displayMax = max;

  if (size === "small" && userCount > max) {
    displayMax = max - 1;
    plusCount = userCount - displayMax;
  }

  return (
    <div className={styles.block}>
      <div className={wrapperClass} data-testid="facepile">
        {userCount > 0 &&
          users.slice(0, displayMax).map((user) => (
            <div
              className={circleClassNames.join(" ")}
              key={user.id}
              title={user.name}
              data-testid="facepile-face"
              onClick={() => onUserClick?.(user)}
            >
              <ProfilePic
                dimensions={dimensions}
                size={size}
                user={user}
                icon={profilePicIconOverride}
                activeFace={
                  highlightActiveFace && active && user.id === activeUserId
                }
              />
            </div>
          ))}
        {userCount > max && (
          <div className={overflowClassNames} onClick={onUserCountClick}>
            <div
              className={styles.maxCount}
              data-testid="facepile-additional-people"
            >{`+${plusCount}`}</div>
          </div>
        )}
        {Boolean(tag) && (
          <div className={styles.tag} data-testid="facepile-tag">
            <span className={styles.tagText}>{tag}</span>
          </div>
        )}
      </div>
    </div>
  );
}
